<template>
  <div>
    <div class="container-base format-detail">
      <div class="flex align-items-center">
        <h1>{{ format.title }}</h1>
      </div>
      <div class="card detail" v-if="formatId != 'rirekisho_ai_career'">

        <div class="card-thumbnail">
          <ul class="doc-sample-images">
            <li v-for="(img, index) in format.images" :key="index"><img :src="img"
                :alt='`${format.title}テンプレート ${index}`'></li>
          </ul>
        </div>
        <div class="card-data">
          <div class="description">{{ format.description }}</div>
          <el-button class="button-block" v-if="formatId == 'shokumukeirekisho' && $site.appFlag != 'b' && false"
            type="primary" @click="openKeirekisho()" v-ripple>様々な種類の職務経歴書を見る</el-button>
          <br>
          <router-link :to="{ name: 'formatEdit', params: { formatId: format.id } }" v-ripple>
            <el-button class="button-block" type="primary" v-ripple>入力をはじめる</el-button>
          </router-link>

          <div class="text-center bakup-btn" v-if="getMode != 'pXroduction'">
            <el-button v-if="isLatestSavedata" @click.prevent="confirmBackup()" type="text">
              <span class="autosave-status on"><i class="el-icon-upload"></i>
                保存データを使う</span>
              <!--<span v-else class="autosave-status on"><i class="el-icon-eleme"></i>
                保存データがありません</span>-->
            </el-button>
          </div>

          <div class="text-center">
            <el-button @click="$eventHub.$emit('open-account-dialog')" type="text">
              <span v-if="$yagi.profile.autoSaveEnabled" class="autosave-status on"><i class="el-icon-circle-check"></i>
                ブラウザに自動保存: オン</span>
              <span v-else class="autosave-status off"><i class="el-icon-circle-close"></i> ブラウザに自動保存: オフ</span>
            </el-button>
          </div>
        </div>

      </div>
    </div>
    <div class="container-base r-ai-format" v-if="formatId == 'rirekisho_ai_career'">
      <div class="card detail">
        <div class="card-thumbnail">
          <ul class="doc-sample-images">
            <li><img src="/static/img/formats/rirekisho_ai_career01.png" alt="転職用のAI履歴書"></li>
            <li><img src="/static/img/formats/rirekisho_ai_career02.png" alt="転職用のAI履歴書"></li>
          </ul>
        </div>
        <div class="card-data">
          <div class="description">
            基本的なJIS規格で文章作成はAIにお任せ！そのままAIで面接練習も可能です。
          </div>
          <router-link :to="{ name: 'formatEdit', params: { formatId: format.id } }" v-ripple>
            <el-button class="button-block" type="primary" v-ripple>入力をはじめる</el-button>
          </router-link>

          <div class="text-center bakup-btn" v-if="getMode != 'pXroduction'">
            <el-button v-if="isLatestSavedata" @click.prevent="confirmBackup()" type="text">
              <span class="autosave-status on"><i class="el-icon-upload"></i>
                保存データを使う</span>
              <!--<span v-else class="autosave-status on"><i class="el-icon-eleme"></i>
                保存データがありません</span>-->
            </el-button>
          </div>

          <div class="text-center">
            <el-button @click="$eventHub.$emit('open-account-dialog')" type="text">
              <span v-if="$yagi.profile.autoSaveEnabled" class="autosave-status on"><i class="el-icon-circle-check"></i>
                ブラウザに自動保存: オン</span>
              <span v-else class="autosave-status off"><i class="el-icon-circle-close"></i> ブラウザに自動保存: オフ</span>
            </el-button>
          </div>
        </div>
      </div>
    </div>

    <!--おすすめ-->
    <div v-if="$firebase.isAuthenticated && ($globalVar.isYagiPrime && !$globalVar.isYagiPrimeCancel)"
      class="container-base top_yagiprime_bnr">
      <a href="/yagiprimeinfo" target="_blank">
        <img src="/static/renew3_img/top_primebnr_pc.png" alt="ヤギプライム加入" class="pc top_yagiprime_bnrimg">
        <img src="/static/renew3_img/top_primebnr_sp.png" alt="ヤギプライム加入" class="sp top_yagiprime_bnrimg">
      </a>
    </div>

    <modal name="confirm-backup-dialog" :adaptive="true" :scrollable="true" height="auto"
      @opened="setPreviewScale(); previewLoading = false">
      <div class="v--modal-close-top">
        <el-button @click="closeDialog" icon="el-icon-close" type="text"></el-button>
      </div>
      <div class="backup-preview-dialog">
        <div class="formats-info">
          <div>
            <p class="title">{{ formattedBackupData.label }}</p>
            <p class="lead">最新の保存データです。このデータを使うと、現在入力中のデータに<span>上書きされるのでご注意ください。</span></p>
          </div>
          <div class="date">保存日時：{{ $formLib.dateFormat(formattedBackupData.lastSaveDate, 'yyyy年mm月dd日HH時MM分') }}</div>
        </div>
        <el-tabs v-model="activePreviewTab" class="backup-tabs" :stretch="true"
          @tab-click="setPreviewScale(); previewLoading = false">
          <el-tab-pane label="履歴書" name="format_rirekisho" :lazy="true" :style="backupDataViewerCssRirekisho">
            <component v-bind:is="rirekisho_preview" ref="backupDataViewer" :id-prefix="'backup'" :format-id="formatId"
              :format-data="formattedBackupData.format_rirekisho" :basic-data="formattedBackupData.basicData"
              :preview-scale="previewScale"></component>
          </el-tab-pane>
          <el-tab-pane label="職務経歴書" name="format_shokumukeirekisho" :lazy="true"
            :style="backupDataViewerCssShokurekisho">
            <component v-bind:is="keirekisho_preview" ref="backupDataViewer" :id-prefix="'backup'" :format-id="formatId"
              :format-data="formattedBackupData.format_shokumukeirekisho" :basic-data="formattedBackupData.basicData"
              :preview-scale="previewScale"></component>
          </el-tab-pane>
          <el-tab-pane :label="etcLabel" name="format_etc" :lazy="true" :style="backupDataViewerCssRirekisho">
            <component v-bind:is="etc_preview" ref="backupDataViewer" :id-prefix="'backup'" :format-data="formatEtc"
              :basic-data="formattedBackupData.basicData" :preview-scale="previewScale"></component>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="text-right">
        <el-button type="primary" @click="loadBackup()">このデータを使う</el-button>
        <el-button @click="closeDialog">閉じる</el-button>
      </div>
      <br /><br />
    </modal>
  </div>
</template>

<style lang="scss" scoped>
.top_yagiprime_bnr {
  margin-top: 30px;
  margin-bottom: 30px;
}

.title {
  font-size: 16px;
  font-weight: bold;
  color: #0f9934;
}

.lead {
  margin-bottom: 20px;

  span {
    color: #E3165C;
  }
}

.bakup-btn {
  ::v-deep .el-button {
    width: 100%;
    background: #fff;
    border: 1px solid #E3165C;
    margin: 8px 0;
  }
}
</style>
<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import LetterPreview from '@/components/formats/LetterPreview'

import NewRirekishoPreview from '@/components/formats/NewRirekishoPreview'

import _ from '@/assets/lib/my-lodash'

const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'
// バックアップ対象
// 'yagiProfile'は端末ごとに持たせるため除外
const BACKUP_KEYS_LIST = [
  'format_rirekisho',
  'format_shokumukeirekisho',
  'format_letter',
  'format_etc',
  'format_taishokutodoke',
  'basicData',
  'recentEdit',
  LAST_SAVE_DATE_SAVE_KEY
]
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  props: {
    formatId: {
      type: String
    },
    univId: {
      type: String
    }
  },
  components: {
    'rirekisho-preview': RirekishoPreview,
    'shokurekisho-preview': ShokurekishoPreview,
    'letter-preview': LetterPreview,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
  },
  data: function () {
    return {
      isRirekisho: false,
      isKeirekisho: false,
      isEtc: false,
      rirekisho_preview: RirekishoPreview,
      keirekisho_preview: ShokurekishoPreview,
      etc_preview: LetterPreview,
      isLatestSavedata: true,
      previewScale: 1,
      backupDataToConfirm: null,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      previewLoading: false,
      rirekisho_height: 110,
      deleteBackupPopoverVisible: false,
      keirekisho_height: 110,
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho',
      etcLabel: 'その他',
      backupList: {
        auto: [],
        user: []
      },
      formatEtc: {},
      lastestBackupdata: {},
      backupListLoaded: {
        auto: false,
        user: false
      },
    }
  },
  computed: {
    formattedBackupData: function () {
      const app = this
      return {
        lastSaveDate: app.lastestBackupdata.lastSaveDate,
        label: '保存データ',
        format_rirekisho: app.lastestBackupdata.format_rirekisho || {},
        format_shokumukeirekisho: app.lastestBackupdata.format_shokumukeirekisho || {},
        format_letter: app.lastestBackupdata.format_letter || {},
        format_taishokutodoke: app.lastestBackupdata.format_taishokutodoke || {},
        basicData: app.lastestBackupdata.basicData || {}
      }
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    format: function (id) {
      return this.$site.getFormatById(this.formatId)
    }
  },
  methods: {
    selectFormat: function (formatId) {
      for (let key in this.$site.rirekishoFormatsIndex) {
        let item = this.$site.rirekishoFormatsIndex[key]
        if (item.id == formatId) {
          this.rirekisho_preview = item.components.preview
          this.isRirekisho = true
          this.activePreviewTab = 'format_rirekisho'
        }
      }
      for (let key in this.$site.keirekishoFormatsIndex) {
        let item = this.$site.keirekishoFormatsIndex[key]
        if (item.id == formatId) {
          this.keirekisho_preview = item.components.preview
          this.isKeirekisho = true
          this.activePreviewTab = 'format_shokumukeirekisho'
        }
      }
      for (let key in this.$site.etcFormatsIndex) {
        let item = this.$site.etcFormatsIndex[key]
        if (item.id == formatId) {
          this.etc_preview = item.components.preview
          this.isEtc = true
          this.formatEtc = this.formattedBackupData[`format_${item.formatDataType}`]
          this.activePreviewTab = 'format_etc'
          this.etcLabel = item.title
        }
      }
    },
    loadBackup: function () {
      let errors = []
      const app = this

      this.$confirm('入力中のデータがサーバーのデータに置き換えられます。本当によろしいでしょうか。', '要確認', {
        confirmButtonText: '置き換え',
        cancelButtonText: 'キャンセル',
        type: 'warning'
      }).then(() => {
        _.forEach(BACKUP_KEYS_LIST, function (key) {
          if (app.lastestBackupdata.hasOwnProperty(key)) {
            let dataForLocal = app.lastestBackupdata[key]
            app.$setItem(key, dataForLocal, function (err) {
              if (err) {
                console.error(err)
                errors.push(err)
                return
              }
            })
          }
        })

        app.closeDialog()
        app.$message({
          type: 'success',
          message: 'サーバーのデータで置き換えました。'
        });
      }).catch(() => {
        app.$message({
          type: 'info',
          message: '操作キャンセルします'
        });
      });


    },
    setPreviewScale: function () {
      this.$nextTick(function () {
        // this.selectFormat(this.formatId)
        if (this.$refs.backupDataViewer.$el.clientWidth === 0) {
        } else {
          const clientWidth = this.$refs.backupDataViewer.$el.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
          console.log(clientWidth, this.previewScale)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      const height = this.$refs.backupDataViewer.$refs.previewMain.getBoundingClientRect().height
      // const height = 10
      if (!height) {
        return
      }
      if (this.activePreviewTab === 'format_rirekisho' && height > 0) {
        this.backupDataViewerCssRirekisho = {
          height: height + 30 + 'px'
        }
      } else if (this.activePreviewTab === 'format_shokumukeirekisho' && height > 0) {
        this.backupDataViewerCssShokurekisho = {
          height: height + 30 + 'px'
        }
      }
    },
    openDialog: function () {
      this.$modal.show('confirm-backup-dialog')
      this.backupDataViewerCssRirekisho = {}
      this.backupDataViewerCssShokurekisho = {}
    },
    closeDialog: function () {
      this.$modal.hide('confirm-backup-dialog')
      this.deleteBackupPopoverVisible = false
    },
    confirmBackup: function () {
      const app = this

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      this.$axios
        .post(this.$varuna.endPoints.getLatestSavedata, formData, { timeout: 60000 })
        .then(function (response) {
          app.lastestBackupdata = response.data.json_data
          app.selectFormat(app.formatId)
          app.openDialog()
          app.previewLoading = true
        })
        .catch(function (error) {
        }).finally(function () {
        })
      return

    },
    openKeirekisho: function () {
      let link = document.createElement('a')
      link.href = 'https://bit.ly/3tXEmBS'
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  },
  beforeMount: function () {

    for (let key in this.$site.rirekishoFormatsIndex) {
      let item = this.$site.rirekishoFormatsIndex[key]
      console.error(item.id + "：")
    }
    for (let key in this.$site.keirekishoFormatsIndex) {
      let item = this.$site.keirekishoFormatsIndex[key]
      console.error(item.id + "：")
    }
    console.error(this.univId)
    if (this.$route.query.ap) {
      console.error("this.$route.query.ap")
      this.$cookies.config(60 * 60 * 24, '')
      this.$cookies.set('_YAGISH_ESF_AP_ID', this.$route.query.ap, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_ESF_AP_ID', this.$route.query.ap, null, null, 'localhost')
      console.error(this.$route.query.ap)

    }
    if (this.univId) {
      this.$cookies.config(60 * 60 * 24, '')
      this.$cookies.set('_YAGISH_ATHLETE_UNIVID', this.univId, null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_ATHLETE_UNIVID', this.univId, null, null, 'localhost')
    }
    if (!this.format) {
      this.$router.replace({
        name: 'notFound'
      })
    }

  }
}
</script>
